import React, { useState, useEffect } from 'react';
import Modal from '@material-ui/core/Modal';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import { Col, Row, Button } from 'reactstrap';
import AlertModal from '../../../../../shared/components/Modal';
import Spinner from 'react-bootstrap/Spinner';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import MomentUtils from '@date-io/moment';
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import moment from 'moment';

const defaultMaterialTheme = createMuiTheme({
    palette: {
        primary: {
            main: '#3EA3FC',
            contrastText: "#fff"
        },

    },
});

const ModalDatesInvoice = ({ closeModal, opened, fechaEmision, fechaVencimiento, numFacTer, idFactura, closeModalConfirm }) => {

    const [loading, setLoading] = useState(false);
    const [emisionDate, setEmisionDate] = useState(moment(fechaEmision).toDate());
    const [expirationDate, setExpirationDate] = useState(moment(fechaVencimiento).toDate());
    const [colorAlertModal, setColorAlertModal] = useState("");
    const [messageAlertModal, setMessageAlertModal] = useState("");
    const [showAlertModal, setShowAlertModal] = useState(false);

    useEffect(() => {

    }, []);

    const confirmChangeDatesInvoice = async () => {
        setLoading(true);
        await fetch(`${process.env.REACT_APP_PUBLIC_URL}facturas/actualizar-fechas`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: JSON.stringify({
                id_factura_t: idFactura,
                fecha_emision: moment(emisionDate).format("YYYY-MM-DD"),
                vencimiento: moment(expirationDate).format("YYYY-MM-DD")
            })
        }).then((response) => {
            if (response.status != 500 && response.status != 403) {
                return response.json();
            }
            else {
                throw new Error("Ha ocurrido un error en el Servidor");
            }
        }).then((dataInvoice) => {
            setMessageAlertModal("Fechas de la Factura confirmadas correctamente");
            setColorAlertModal("success");
            setShowAlertModal(true);
            setLoading(false);
        }).catch(err => {
            setMessageAlertModal("Ha ocurrido un error en el Servidor");
            setColorAlertModal("danger");
            setShowAlertModal(true);
            setLoading(false);
        });
    }

    const onOkModal = () => {
        setShowAlertModal(false);
        if (colorAlertModal == "success") {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
            closeModalConfirm();
        }
        else if (colorAlertModal == "warning") {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
            confirmChangeDatesInvoice();
        }
        else {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
        }
    }

    const onToggleModal = () => {
        setShowAlertModal(false);
        if (colorAlertModal == "success") {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
            closeModalConfirm();
        }
        else if (colorAlertModal == "warning") {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
        }
        else {
            setShowAlertModal(false);
            setMessageAlertModal("");
            setColorAlertModal("");
        }
    }

    return (
        <div>
            <Modal
                open={opened}
                onClose={e => {
                    closeModal();
                }}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                style={{ zIndex: 1000 }}
            >
                <div className="paperAppointment-flex" style={{ width: '100%', margin: 10 }}>
                    <div>
                        <div className="card__title">
                            <h5 className="bold-text">Cambiar Fecha de Emision y/o Vencimiento</h5>
                            <br />
                            <h6 className="bold-text">Factura: {numFacTer}</h6>
                        </div>
                        <br />
                    </div>

                    <div>
                        <Row>
                            <Col xs={12} sm={6}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <KeyboardDatePicker
                                            label="Fecha Emisión"
                                            openTo="date"
                                            variant="inline"
                                            value={emisionDate}
                                            onChange={(date) => {
                                                setEmisionDate(date);
                                            }}
                                            format="DD/MM/YYYY"
                                            animateYearScrolling
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                shrink: true,
                                                style: { color: '#646777' }
                                            }}
                                            autoOk={true}
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>
                            </Col>
                            <Col  xs={12} sm={6}>
                                <MuiPickersUtilsProvider utils={MomentUtils} >
                                    <ThemeProvider theme={defaultMaterialTheme}>
                                        <KeyboardDatePicker
                                            label="Fecha de Vencimiento"
                                            openTo="date"
                                            variant="inline"
                                            value={expirationDate}
                                            onChange={(date) => {
                                                setExpirationDate(date);
                                            }}
                                            format="DD/MM/YYYY"
                                            animateYearScrolling
                                            className="medical-material-form__field"
                                            InputLabelProps={{
                                                shrink: true,
                                                style: { color: '#646777' }
                                            }}
                                            autoOk={true}
                                        />
                                    </ThemeProvider>
                                </MuiPickersUtilsProvider>
                            </Col>
                        </Row>
                    </div>

                    <div style={{ display: 'flex', justifyContent: 'flex-end' }}>

                        <Button
                            disabled={false}
                            style={{ marginTop: 10, marginRight: 10 }}
                            variant="contained"
                            className="btn btn-primary btn-sm text-white"
                            onClick={() => {
                                setShowAlertModal(true);
                                setMessageAlertModal("Esta completamente seguro de confirmar las Fechas de la Factura");
                                setColorAlertModal("warning");
                            }}
                        >
                            Confirmar
                        </Button>

                        <Button
                            style={{ marginTop: 10 }}
                            variant="contained"
                            className="btn btn-secondary btn-sm"
                            onClick={() => {
                                closeModal();
                            }}
                        >
                            Cerrar
                        </Button>
                    </div>
                </div>
            </Modal>

            {
                <AlertModal
                    color={colorAlertModal}
                    title={messageAlertModal}
                    modal={showAlertModal}
                    onOk={() => onOkModal()}
                    toggle={() => onToggleModal()}
                />}
        </div>
    );
};
export default ModalDatesInvoice;
